<template>
  <q-layout view="hHh lpR fFf">
    <component :is="$config.layoutBasic.header"
      ref="header"
      :brand-logo="$config.branding.header.logo"
      :brand-text="$config.branding.header.text"
    />
    <q-page-container>
      <router-view />
    </q-page-container>
  </q-layout>
</template>

<script>
import { QLayout, QPageContainer } from 'quasar'

export default {
  name: 'MainLayout',
  components: { QLayout, QPageContainer }
}
</script>
